import api from './index';

export default {
	upload_image(data) {
		return api().post('/image', data)
	}
}